<template>
  <div>
    <a-button style="margin:10px 0 20px 0" @click="handleAdd" >添加</a-button>
    <s-table
      size="default"
      :columns="columns"
      :data="loadData"
      @add_hospital_ok="reloadData"
      ref="datatable"
      :showPagination=true
    >
      <span slot="action" slot-scope="text, record">
        <a-tag size="small" color="blue" @click="handleEdit(record)">编辑</a-tag>
        <a-tag size="small" color="red" @click="handleDelete(record)">删除</a-tag>
      </span>
    </s-table>
    <add-hospital-modal @ok="reloadData" ref="addHospitalModal"/>
  </div>
</template>

<script>
import STable from '@/components/table/'
import { getHospitalList, deleteHospital } from '@/api/hospital'
import { axios } from '@/utils/request'
import AddHospitalModal from './modules/AddHospitalModal'

export default {
  name: 'HospitalList',
  components: {
    STable,
    AddHospitalModal
  },
  data () {
    return {
      // 表头
      columns: [
        {
          title: '编号',
          dataIndex: 'source_id',
          key: 'source_id'
        },
        {
          title: '来源名称',
          dataIndex: 'source_name',
          key: 'source_name'
        },
        {
          title: '数量',
          dataIndex: 'data_count',
          key: 'data_count'
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (page) => {
        return new Promise(resolve => {
          const _this = this
          return getHospitalList({
            item_id: _this.$store.getters.projectId,
            page_num: page.pageNo,
            page_size: page.pageSize
          })
            .then(res => {
              if (res.data.length == 0) {
                _this.$refs.datatable.localLoading = false
                return { data: [] }
              }
              const datas = []
              for (let item = res.data.shift(); item != null; item = res.data.shift()) {
                datas.push({
                  source_id: item.source_id,
                  source_name: item.source_name,
                  data_count: item.data_count,
                  item_id: item.item_id
                })
              }

              const params = {
                data: datas,
                pageNo: page.pageNo,
                pageSize: page.pageSize,
                totalCount: res.total
              }
              resolve(params)
            }).catch(res => {
              _this.$refs.datatable.localLoading = false
            })
        })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  methods: {
    handleEdit (record) {
      this.$refs.addHospitalModal.edit(record)
    },
    reloadData () {
      // true 回到第一页
      this.$refs.datatable.refresh(true)
      this.$store.dispatch('FetchProjectHospitals')
    },
    handleAdd () {
      this.$refs.addHospitalModal.add()
    },
    handleDelete (record) {
      const _this = this
      _this.$confirm({
        title: '真的要删除来源“' + record.source_name + '”吗？',
        content: '单击确定删除',
        onOk () {
          return new Promise((resolve, reject) => {
            const hospitalId = record.source_id
            deleteHospital(hospitalId).then(res => {
              _this.$message.success('删除成功')
              resolve()
            }).catch(() => {
              _this.$message.error('删除失败')
              reject()
            }).finally(() => {
              _this.reloadData()
            }
            )
          })
        },
        onCancel () {}
      })
    }
  }
}
</script>
